import React, { useState } from 'react';
import { Box } from '@mui/system';
import styled from '@emotion/styled';
import {Paper, Typography} from '@mui/material';
import BusinessCenterOutlinedIcon from '@mui/icons-material/BusinessCenterOutlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import ScienceOutlinedIcon from '@mui/icons-material/ScienceOutlined';
import {MyBarChartCard} from "./600/MyCards";
import { MyProgressBar } from "./600/MyProgressBars";

const DetailsBox=styled(Box)(({theme})=>({
  width: "258px",
  height: "111px",
  background: theme.palette.background.default,
  boxShadow: `0px 0px 7px ${theme.palette.background.shadow}`,
  borderRadius: "15px",
  display:'flex',
  justifyContent:'space-around',
  alignItems:'center',

}));
const IconHolder=styled(Box)(({theme})=>({
        color:theme.palette.secondary.dark,
        display:'flex',
        alignItems:'center',
        justifyContent:'center',
        backgroundColor:theme.palette.background.icon,
        boxShadow: `0px 2px 10px ${theme.palette.background.iconShadow}`,
        borderRadius: '12px',
        width: '44px',
        height: '44px',

}));
const StyledPaper = styled(Paper)(({ theme }) => ({
  minHeight: "100px",
  width: "258px",
  fontSize: "11px",
  background: theme.palette.background.default,
  boxShadow: `0px 0px 7px ${theme.palette.background.shadow}`,
  borderRadius: "15px",
}));
const MyBarChartPaper2 = styled(StyledPaper)(({ theme }) => ({
  padding: `${theme.spacing(1)}`,
  paddingLeft: `${theme.spacing(2)}`,
  paddingRight: `${theme.spacing(2)}`,
}));
function Details(props) {
const option1=props.option1
const option2=props.option2
const option3=props.option3
const value1=props.value1
const value2=props.value2
const value3=props.value3

const [detail,setDetail]=useState(true)
  return (
    detail?
    <DetailsBox onClick={()=>{props.text==="Total WorkLoad" && setDetail((prev)=>!prev)}} sx={{cursor:props.text==="Total WorkLoad" &&"pointer"}}> 
        <Box>
        <Typography sx={{
          fontWeight: 600,
          fontSize: "28px",
        }}>
          { props.value}
        </Typography>
        <Typography sx={{
          fontWeight: 400,
          fontSize: "16px",
          color: 'secondary.light',
          
        }}>
        {props.text}
        </Typography>
      </Box>
      <IconHolder>
      {(() => {
          switch (props.icon) {
            case "work":
              return <BusinessCenterOutlinedIcon fontSize="small" />;
            case "teach":
              return <MenuBookOutlinedIcon fontSize="small" />;
            case "research":
              return <ScienceOutlinedIcon fontSize="small" />;
            default:
              return <BusinessCenterOutlinedIcon fontSize="small" />;
          }})()}
      </IconHolder>
        
    </DetailsBox>:
      <MyBarChartPaper2 onClick={()=>{setDetail((prev)=>!prev)}} sx={{cursor:props.text==="Total WorkLoad" &&"pointer"}}>
        <Typography
          color="secondary"
          sx={{ fontSize: "15px", fontWeight: "500", textDecoration:"underline" }}>
          {"Load Details"}
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}>
          <Typography variant="p">{option1}</Typography>
          <Typography variant="p">{value1}</Typography>
        </Box>
        <MyProgressBar
          variant="determinate"
          value={(value1 / (value1 + value2 + value3)) * 100}
          color="primary"
        />
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mt: 2,
          }}>
          <Typography variant="p">{option2}</Typography>
          <Typography variant="p">{value2}</Typography>
        </Box>
        <MyProgressBar
          variant="determinate"
          value={(value2 / (value1 + value2 + value3)) * 100}
          color="secondary"
        />
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mt: 2,
          }}>
          <Typography variant="p">{option3}</Typography>
          <Typography variant="p">{value3}</Typography>
        </Box>
        <MyProgressBar
          variant="determinate"
          value={(value3 / (value1 + value2 + value3)) * 100}
          color="secondary"
        />
      </MyBarChartPaper2>
  )
}
export default Details;
